module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_32.bdce5d70.png";